import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {FeatureNotEnabledError} from '../../shared/Errors/FeatureNotEnabledError.js'
import {SellerRepositoriesFactory} from '../Repositories/factory.js'
import {ContactConfiguratorSellerRequest} from '../Requests/ContactConfiguratorSellerRequest.js'

class ContactConfiguratorSellerUseCase extends UseCase {
  #repository
  #isFeatureEnabled

  constructor({repository, isFeatureEnabled}) {
    super()
    this.#repository = repository
    this.#isFeatureEnabled = isFeatureEnabled
  }

  static create({config, repository}) {
    const isMotos = config.get('APP_NAME') === config.get('APP_NAME_MOTOS')
    return new ContactConfiguratorSellerUseCase({
      repository: SellerRepositoriesFactory.hTTPSellerRepository({config}),
      isFeatureEnabled: !isMotos
    })
  }

  @tracer({metric: 'ContactConfiguratorSellerUseCase#execute'})
  @AsyncInlineError()
  async execute(params) {
    if (!this.#isFeatureEnabled) {
      return Promise.reject(FeatureNotEnabledError.create('Feature not enabled'))
    }
    const {userId, dealerId, vehicleId, color} = params
    const contactConfiguratorSellerRequest = ContactConfiguratorSellerRequest.create({
      userId,
      dealerId,
      vehicleId,
      color
    })
    const [error, response] = await this.#repository.contactConfiguratorSeller({contactConfiguratorSellerRequest})

    if (error) return Promise.reject(error)

    return response
  }
}

export const factory = ContactConfiguratorSellerUseCase.create
